import React from "react";
import StudyAbroadBanner from "../../AVHRBanner/TeamBuildingBannerN2.jpg";
import {
  FaUsers,
  FaHandshake,
  FaBullseye,
  FaHeart,
} from "react-icons/fa";
import { Card } from "primereact/card";
import { useNavigate } from "react-router-dom";
import { Button } from "primereact/button";


function TeamBuilding() {
  const navigate = useNavigate();

  const handleNavigate = (path) => {
    navigate(path);
    window.scrollTo(0, 0);
  };

  const studypoints = [
    "Backed by years of academic and industry knowledge",
    "Personalized mentorship from global education experts ",
    "Ethical guidance, with student-first values ",
    "Focused on clarity, confidence, and successful outcomes ",
  ];


  return (
    <>
      <div style={{ paddingTop: "100px" }}>
        <div className="relative w-full h-[400px] sm:h-[500px] md:h-[600px] lg:h-[700px] xl:h-[800px] banner">
          <img
            src={StudyAbroadBanner}
            className="absolute inset-0 w-full h-full object-cover"
            alt=""
          />

          {/* Centered Content */}
          <div className="relative z-10 flex items-center justify-center h-full px-4 text-adjest">
            <div className="text-bannar max-w-3xl text-left avhrProject-bannerTextColour">
              <p className="edu-support-text uppercase">Our Support</p>

              <h1 className="career-library-heading">Team Building</h1>

              {/* <p className="mt-4 leading-relaxed">
                
              </p> */}
            </div>
          </div>
        </div>

        <div className="w-full px-4 py-4 sm:px-6 md:px-10 lg:px-16">
          <div
            className="rounded-lg text-center p-2 sm:p-2 md:p-6 lg:p-2 shadow-md HeadingTagLine"
            style={{
              boxShadow: "0 6px 12px rgba(0, 0, 0, 0.25)",
            }}
          >
            <h1 className="mb-2 avhrProject-h1">
              Transform Individuals into High-Performing Teams
            </h1>
            <p className="avhrProject-p ml-4 mr-4" style={{ fontSize: "20px" }}>
              Our team-building programs are designed to foster strong
              collaboration, mutual trust, and high performance. We help groups
              evolve into cohesive teams that thrive together
            </p>
          </div>
        </div>

        <div
          className="px-3 sm:px-5 lg:px-8 pt-2"
          style={{ backgroundColor: "#FCFFC1" }}
        >
          <h2 className="mb-4 avhrProject-h2">Benefits of Team Building</h2>

          <div className="grid">
            <div className="col-12 grid">
              {/* Box 1 */}
              <div className="col-12 lg:col-6 flex align-items-start gap-3 mb-1">
                <span className="text-5xl mt-4">🚀</span>
                <div>
                  <h3 className="mb-2 avhrProject-h3">Enhanced Performance</h3>
                  <p className="avhrProject-p">
                    Team members learn to work together more effectively,
                    leading to better coordination, smoother workflows, and
                    increased productivity
                  </p>
                </div>
              </div>

              {/* Box 2 */}
              <div className="col-12 lg:col-6 flex align-items-start gap-3 mb-1">
                <span className="text-5xl mt-4">🤝</span>
                <div>
                  <h3 className="mb-2 avhrProject-h3">
                    Strong Interpersonal Bonds
                  </h3>
                  <p className="avhrProject-p">
                    Foster stronger relationships, helping individuals
                    understand each other’s strengths and communication styles
                  </p>
                </div>
              </div>

              {/* Box 3 */}
              <div className="col-12 lg:col-6 flex align-items-start gap-3 mb-1">
                <span className="text-5xl mt-4">🎯</span>
                <div>
                  <h3 className="mb-2 avhrProject-h3">
                    Alignment with Common Goals
                  </h3>
                  <p className="avhrProject-p">
                    Teams become more focused and unified when everyone
                    understands and is motivated by shared objectives and a
                    collective mission
                  </p>
                </div>
              </div>

              {/* Box 4 */}
              <div className="col-12 lg:col-6 flex align-items-start gap-3 mb-1">
                <span className="text-5xl mt-4">🌟</span>
                <div>
                  <h3 className="mb-2 avhrProject-h3">
                    Improved Trust and Team Spirit
                  </h3>
                  <p className="avhrProject-p">
                    A trusting environment encourages open dialogue,
                    risk-taking, and a sense of camaraderie, which boosts morale
                    and team resilience
                  </p>
                </div>
              </div>

              {/* Box 5 */}

              <div className="col-12 lg:col-6 flex align-items-start gap-3 mb-1">
                <span className="text-5xl mt-4">🏆</span>
                <div>
                  <h3 className="mb-2 avhrProject-h3">
                    Align personal and team values with organizational purpose
                  </h3>
                  <p className="avhrProject-p">
                    Aligning personal and team values with the organization's
                    purpose builds motivation, encourages collaboration, and
                    strengthens trust within the team
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="w-full px-4 py-4 sm:px-6 md:px-10 lg:px-16">
          <Card
            className="CARDCOLOUR m-3"
            style={{
              background: "linear-gradient(120deg, #D3669E, #FF8A7F, #FFCB5C)",
            }}
          >
            <p className="mb-2 text-center avhrProject-p">
              Let us help build your dream team.
            </p>
            <h3 className="mt-2 text-center teamBuildingBottom-h3 ">
              Watch your group transform into a powerhouse of collaboration and
              performance
            </h3>
            <div className="flex justify-content-center">
              <Button
                label="Contact Us"
                rounded
                onClick={() => handleNavigate("/contactus")}
                className="buttonAvhrProject"
              />
            </div>
          </Card>
        </div>
      </div>
    </>
  );
}

export default TeamBuilding;
